/**
 * The Webwin release this code was built as - `package.json`'s `version`,
 * substituted by the build (`define` in vite.config.ts and vite.lib.config.ts).
 *
 * A vendored copy of `dist/lib` has no package.json beside it, so this is the
 * only way a consuming app, a bug report or the diagnostics page can say which
 * build it is running.
 */
export const VERSION: string = __WEBWIN_VERSION__;
